<template>
  <div>
    <Mainlayout></Mainlayout>
    <div class="mt-5">
              <CContainer>
        <CCol class="col-12 mt-5 text-center">
      
          <CCard style="border-radius: 20px" class="box-shadow mt-5">
            <span class="text-center">
              <img
                v-if="teacherProfile.filepath == null"
                style="border: 1px solid #eee"
                src="../assets/img/default.png"
                class="grey lighten-2 rounded-img img-profile mt-2"
              />

              <img
                v-else
                style="border: 3px solid #ddd; background: #fff"
                :src="photoURL"
                class="grey lighten-2 rounded-img img-profile mt-2"
              />
            </span>
            <br />

            <span class="text-center custom-font">
              <strong> {{ teacherProfile.userName }} </strong>
            </span>
            <div class="text-center custom-font mb-2">
              {{ teacherProfile.userEmail }}
            </div>

            <div class="text-center custom-font mb-2">
              {{ teacherProfile.phoneNumber }}
            </div>
          </CCard>
         
        </CCol>
          </CContainer>
           </div>
     
   

    <!-- Section Teacher Background Start -->
    <CContainer>
      <CCol class="col-12 text-center">
        <CCard style="border-radius: 20px" class="box-shadow col-12 text-black">
          <CRow class="text-left text-black col-12 mt-3">
            <CCol class="col-1">
            </CCol>
            <CCol class="col-10"> Academic Profile : </CCol>
            <CCol class="col-1 text-right">
              <span @click="GoToPageQuizTeacherAcademicProfile()">
                <img src="../assets/img/edit.png" width="20px" height="20px" />
              </span>
            </CCol>
          </CRow>

          <CRow class="text-left col-12">
            <CCol class="col-1"> </CCol>
            <CCol class="col-10">
              <!-- <textarea 
            class="form-input"
            rows="9"
            maxlength="400">
          </textarea> -->

              <strong>
                {{ teacherAcademic == null ? "None" : teacherAcademic.Content }}
              </strong>
            </CCol>
          </CRow>

          <hr />

          <CRow class="text-left text-black col-12">
            <CCol class="col-1">
             
            </CCol>
            <CCol class="col-10"> Work Background : </CCol>
            <CCol class="col-1">
              <span @click="GoToPageQuizTeacherWorkBackground()">
                <img src="../assets/img/edit.png" width="20px" height="20px" />
              </span>
            </CCol>
          </CRow>
          <CRow class="text-left col-12 mb-3">
            <CCol class="col-1"> </CCol>
            <CCol class="col-10">
              <!-- <textarea
            class="form-input"
            rows="9"
            maxlength="400"
            v-model="academicProfile.Content"
          >
          </textarea> -->
              <strong>
                {{
                  teacherWorkBackground == null
                    ? "None"
                    : teacherWorkBackground.Content
                }}
              </strong>
            </CCol>
          </CRow>

          <hr />

          <CRow class="text-left text-black col-12">
            <CCol class="col-1">
            
            </CCol>
            <CCol class="col-10"> Professional Profile : </CCol>
            <CCol class="col-1">
              <span @click="GoToPageQuizTeacherProfession()">
                <img src="../assets/img/edit.png" width="20px" height="20px" />
              </span>
            </CCol>
          </CRow>
          <CRow class="text-left col-12 mb-3">
            <CCol class="col-1"> </CCol>

            <CCol class="col-10">
              <!-- <textarea
            class="form-input"
            rows="9"
            maxlength="400"
            v-model="academicProfile.Content"
          >
          </textarea> -->
              <strong>
                {{
                  teacherProfessional == null
                    ? "None"
                    : teacherProfessional.Content
                }}
              </strong>
            </CCol>
          </CRow>

          <hr />

          <CRow class="text-left text-black col-12">
            <CCol class="col-1">
            </CCol>
            <CCol class="col-10">Area of Expertise : </CCol>
            <CCol class="col-1">
              <span @click="GoToPageQuizTeacherAreaExpertise()">
                <img src="../assets/img/edit.png" width="20px" height="20px" />
              </span>
            </CCol>
          </CRow>
          <CRow class="text-left col-12 mb-3">
            <CCol class="col-1"> </CCol>

            <CCol class="col-10">
              <!-- <textarea
            class="form-input"
            rows="9"
            maxlength="400"
            v-model="academicProfile.Content"
          >
          </textarea> -->
              <strong>
                {{
                  teacherAreasOfExpertise == null
                    ? "None"
                    : teacherAreasOfExpertise.Content
                }}
              </strong>
            </CCol>
          </CRow>
        </CCard>

        <!-- Teacher Background End -->

        <!-- Section Teacher Teach Start -->
        <CCard style="border-radius: 20px" class="box-shadow col-12 text-black">
          <CRow class="text-left col-12 mt-3">
            <CCol class="col-1">
              <img
                src="../assets/img/listsubject.png"
                width="20px"
                height="20px"
              />
            </CCol>
            <CCol class="col-11"> Subject Teach : </CCol>
          </CRow>
          <CRow class="text-left col-12">
            <CCol class="col-1"> </CCol>
            <CCol class="col-11">
              <ul v-for="item in teacherSubGra" v-bind:key="item.Id">
              
              <li>{{ item.subjectName }}  - {{ item.gradeName }}</li>
              </ul>
            </CCol>
          </CRow>
        </CCard>
        <!-- Teacher Teach End -->

        <!-- Section Quiz Published Start -->
        <CCard style="border-radius: 20px" class="box-shadow col-12 text-black">
          <CRow class="text-left text-black col-12 mt-3">
            <CCol class="col-1">
              <img
                src="../assets/img/listquiz.png"
                width="20px"
                height="20px"
              />
            </CCol>
            <CCol class="col-11"> Total Quiz Published : </CCol>
          </CRow>
          <CRow class="text-left col-12 mb-3">
            <CCol class="col-1"> </CCol>
            <CCol class="col-11" style="padding-left: 30px"> 30 Quizzes </CCol>
          </CRow>
        </CCard>
        <!-- Quiz Section Published End -->

        <!-- Button Save -->
          <CButton color="success" class="custom-btn" size="lg" block>
            Save
          </CButton>
          <br /><br />
      </CCol>
    </CContainer>
    
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundBanner from "../assets/img/bgApps.jpg";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import Mainlayout from "../containers/TheHeaderWebTutor.vue";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "Login",
  components: {
    PulseLoader,
    Mainlayout,
  },
  data() {
    return {
      backgroundBanner,
      academicProfile: "",
      //classGrade: {},
      SubmittedForm: false,
      Error: false,
      hasScrolledToBottom: false,
      teacherProfile: {},
      //teacherSubGra: [],
      teacherAcademic: {},
      teacherWorkBackground: {},
      teacherAreasOfExpertise: {},
      teacherProfessional: {},
      photoURL: "",
      message: "",
    };
  },
  async mounted() {
    this.GetAcademicProfile();
    this.GetUserProfile();
    //this.GetTeacherClassGrade();
    await this.GetUserProfile();
    await this.GetTeacherSubjectGrade();
    await this.GetAcademiceProfile();
    await this.GetWorkBackground();
    await this.GetAreaofExpertise();
    await this.GetProfessionalProfile();
  },
  computed: {},
  methods: {
    //Get teacher academic profile
    async GetAcademicProfile() {
      //console.log(this.$route);
      return this.$API
        .get(
          this.$TeacherAcademiceProfile + "?userId=" + this.$route.query.userId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.academicProfile = response.data;
            console.log(this.academicProfile);
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },

   
    async GetUserProfile() {
      this.$API
        .get(this.$TeacherProfile + "?userId=" + this.$route.query.userId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.teacherProfile = response.data;
            this.photoURL =
              "https://pickiddo.com" + this.teacherProfile.filepath;
            $("#profileImage").text(this.photoURL);
          }
        });
    },
    async GetTeacherSubjectGrade() {
      this.$API
        .get(
          this.$TeacherSubjectGrade + "?userId=" + this.$route.query.userId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.teacherSubGra = response.data;
          }
        });
    },
    async GetAcademiceProfile() {
      this.$API
        .get(
          this.$TeacherAcademiceProfile + "?userId=" + this.$route.query.userId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.teacherAcademic = response.data;
          } else {
            this.teacherAcademic = null;
          }
        });
    },
    async GetWorkBackground() {
      this.$API
        .get(
          this.$TeacherWorkBackground + "?userId=" + this.$route.query.userId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.teacherWorkBackground = response.data;
          } else {
            this.teacherWorkBackground = null;
          }
        });
    },
    async GetAreaofExpertise() {
      this.$API
        .get(
          this.$TeacherAreasOfExpertise + "?userId=" + this.$route.query.userId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.teacherAreasOfExpertise = response.data;
          } else {
            this.teacherAreasOfExpertise = null;
          }
        });
    },
    async GetProfessionalProfile() {
      this.$API
        .get(
          this.$TeacherProfessional + "?userId=" + this.$route.query.userId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.teacherProfessional = response.data;
          } else {
            this.teacherProfessional = null;
          }
        });
    },
    SaveResume() {
      this.UpdateProfessionalProfile();
      this.UpdateAreaOfExpertise();
    },
    UpdateProfessionalProfile() {
      if (this.TeacherId == undefined) {
        const formData = new FormData();
        formData.append("Id", 0);
        formData.append("TeacherId", this.$route.query.userId);
        formData.append("Content", this.ProfessionalName);
        formData.append("Status", "active");

        return this.$API
          .post(this.$UpdateProfessionalProfile, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              this.$dialog
                .alert("You have successfully save the professional profile")
                .then(function (dialog) {
                  //console.log("Closed");
                });
            }
          })
          .catch((error) => {
            if (error.response) {
              //console.log(error.response.status);
              this.Error = true;
              this.Message = error;
              this.Message = "Error";
            }
          });
      } else {
        const formData = new FormData();
        formData.append("TeacherId", this.TeacherId);
        formData.append("Id", this.ProfessionalId);
        formData.append("Content", this.ProfessionalName);
        formData.append("Status", "active");

        return this.$API
          .post(this.$UpdateProfessionalProfile, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              this.$dialog
                .alert("You have successfully save the professional profile")
                .then(function (dialog) {
                  console.log("Closed");
                });
            }
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response.status);
              this.Error = true;
              this.Message = error;
              this.Message = "Error";
            }
          });
      }
    },
    UpdateAreaOfExpertise() {
      if (this.TeacherId == undefined) {
        const formData = new FormData();

        formData.append("TeacherId", this.$route.query.userId);
        formData.append("Id", 0);
        formData.append("Content", this.AreaExpertise);
        formData.append("Status", "active");

        return this.$API
          .post(this.$UpdateAreaOfExpertise, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              this.$dialog
                .alert("You have successfully save the area of expertise")
                .then(function (dialog) {
                  //console.log("Closed");
                });
            }
          })
          .catch((error) => {
            if (error.response) {
              //console.log(error.response.status);
              this.Error = true;
              this.Message = error;
              this.Message = "Error";
            }
          });
      } else {
        const formData = new FormData();

        formData.append("TeacherId", this.TeacherId);
        formData.append("Id", this.AreaId);
        formData.append("Content", this.AreaExpertise);
        formData.append("Status", "active");

        return this.$API
          .post(this.$UpdateAreaOfExpertise, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              this.$dialog
                .alert("You have successfully save the area of expertise")
                .then(function (dialog) {
                  //console.log("Closed");
                });
            }
          })
          .catch((error) => {
            if (error.response) {
              //console.log(error.response.status);
              this.Error = true;
              this.Message = error;
              this.Message = "Error";
            }
          });
      }
    },
    GoToPageQuizTeacherAcademicProfile() {
      this.$router.push(
        "/QuizTeacherAcademicProfile?userId=" + this.$route.query.userId
      );
    },

    GoToPageQuizTeacherWorkBackground() {
      this.$router.push(
        "/QuizTeacherWorkBackground?userId=" + this.$route.query.userId
      );
    },

    GoToPageQuizTeacherProfession() {
      this.$router.push(
        "/QuizTeacherProfession?userId=" + this.$route.query.userId
      );
    },

    GoToPageQuizTeacherAreaExpertise() {
      this.$router.push(
        "/QuizTeacherAreaExpertise?userId=" + this.$route.query.userId
      );
    },
  },
};
</script>

<style>
#fb-root{
  display:none;
}
</style>